<script setup>
import { ref } from 'vue';
import { storeToRefs } from "pinia";
import { useMailLogStore} from "../stores/maillog";
import { RefreshRight,CircleCloseFilled, Loading } from "@element-plus/icons-vue";

const store = useMailLogStore();
const { disableSingleSelectActions,singleMailSelectedData } = storeToRefs(store);
const showResendDialog = ref(false);
const attachedFiles = ref('');
const isSending = ref(false);

const toEmail = ref([]);
const ccEmail = ref([]);
const bccEmail = ref([]);

const sendToEmail = ref([]);
const sendCcEmail = ref([]);
const sendBccEmail = ref([]);

const mailHeader = ref([]);

const onOpen = (e) => {
    showResendDialog.value = true;
    const data = singleMailSelectedData.value;
    attachedFiles.value = singleMailSelectedData.value?.dataFile;

    const header = data['headers'].split(/\r?\n/);
    var mailHeaderUpdate = [];
    header.forEach((h) => {
        if (h !== '') {
            var split = h.split(':');
            mailHeaderUpdate[split[0].trim()] = split[1].trim(); 
        }
    });
    mailHeader.value = mailHeaderUpdate;

    toEmail.value = data['to_email'].split(",").map(item => item.trim());
    ccEmail.value = mailHeaderUpdate['Cc']?.split(',').map(item => item.trim()) || [];
    bccEmail.value = mailHeaderUpdate['Bcc']?.split(',').map(item => item.trim()) || [];

    sendToEmail.value = data['to_email'].split(",").map(item => item.trim());
    sendCcEmail.value = mailHeaderUpdate['Cc']?.split(',').map(item => item.trim()) || [];
    sendBccEmail.value = mailHeaderUpdate['Bcc']?.split(',').map(item => item.trim()) || [];
}
const onToEmailCheckChange = (checked,checkbox) => {
    var emails = sendToEmail.value;

    if (checked) {
        emails.push(checkbox.target.id.trim());
        // emails = emails.filter(e => e.trim() !== checkbox.target.id);
    } else {
        emails = emails.filter(e => e.trim() !== checkbox.target.id);
    }

    sendToEmail.value = emails;
}
const ccEmailCheckChange = (checked,checkbox) => {
    var emails = sendCcEmail.value;
    if (checked) {
        emails.push(checkbox.target.id);
    } else {
        emails = emails.filter(e => e.trim() !== checkbox.target.id);
    }

    sendCcEmail.value = emails;
}

const bccEmailCheckChange = (checked,checkbox) => {
    var emails = sendBccEmail.value;
    if (checked) {
        emails.push(checkbox.target.id);
    } else {
        emails = emails.filter(e => e.trim() !== checkbox.target.id);
    }

    sendBccEmail.value = emails;
}

const onConfirm = async (e) => {
    isSending.value = true;
    mailHeader.value['Cc'] = sendCcEmail.value;
    mailHeader.value['Bcc'] = sendBccEmail.value;

    var headerStr = '';
    Object.keys(mailHeader.value).forEach(k => {
        if (mailHeader.value[k] && mailHeader.value[k].length) {
            headerStr += `${k}: ${mailHeader.value[k]} \n`;
        }
    });

    const form_data = new FormData();
    form_data.append('id', singleMailSelectedData.value['id']);
    form_data.append('to_email', sendToEmail.value);
    form_data.append('type', 'resend');
    form_data.append('headers', headerStr);

    await store.forwardEmail(form_data);
    isSending.value=false;
    showResendDialog.value = false;
    // const response = await sendMail(sendData);
}
</script>

<template>
    <span>
        <el-button titie="Resend" :icon="RefreshRight" type="primary" @click="onOpen"  :disabled="disableSingleSelectActions" circle />
        <div class="wml-mail-resend">
            <el-dialog
                v-model="showResendDialog"
                width="30%"
                :with-header="true"
                :show-close="false"
            >
            <template #header="{ close, titleId, titleClass }">
            <div class="wml-mail-actions">
                <div class="wml-input-group">
                    Resend Email
                </div>
            </div>
            
            <el-button type="danger" :round="false" @click="close">
                <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
                Close
            </el-button>
        </template>
            <el-row v-if="toEmail.length">
                <el-col :span="8">
                    To
                </el-col>
                <el-col :span="16">
                    <el-checkbox v-for="(email,index) in toEmail" :key="index" checked
                        :id="email" :label="email" :name="email" @change="(checked,event) => onToEmailCheckChange(checked,event)"/>
                </el-col>
                <el-divider />

            </el-row>
            <el-row v-if="ccEmail.length">
                <el-col :span="8">
                    CC Email
                </el-col>
                <el-col :span="16">
                    <el-checkbox v-for="(email,index) in ccEmail" :key="index" checked
                    :id="email" :label="email" :name="email" @change="(checked,event) => ccEmailCheckChange(checked,event)"/>
                </el-col>
                <el-divider />
            </el-row>
            <el-row v-if="bccEmail.length">
                <el-col :span="8">
                    BCC Email
                </el-col>
                <el-col :span="16">
                    <el-checkbox v-for="(email,index) in bccEmail" :key="index" checked
                    :id="email" :label="email" :name="email" @change="(checked,event) => bccEmailCheckChange(checked,event)"/>
                </el-col>
                <el-divider />
            </el-row>
            <el-row v-if="attachedFiles">
                <el-col :span="8">
                    Attachents
                </el-col>
                <el-col :span="16">
                    <div v-for="(file,index) in attachedFiles" :key="index">
                        {{file.exist ? file.name : file.name}}
                    </div>
                </el-col>
                <el-divider />
            </el-row>
            <template #footer>
                <span class="dialog-footer">
                <el-button @click="showResendDialog = false">Cancel</el-button>
                <el-button type="primary" :icon="isSending ? Loading : ''" @click="onConfirm">
                    Confirm
                </el-button>
                </span>
            </template>
            </el-dialog>
        </div>
    </span>
</template>
